import React, { useEffect, useState } from 'react';
import ReactECharts from 'echarts-for-react';
import { fetchPriceTrend } from '../../api/dashboard';
interface Props {
    activeRegion: string;
}
const MarketPanel: React.FC<Props> = ({ activeRegion }) => {
    const isChengde = activeRegion === 'Chengde';
    const highlightColor = isChengde ? '#ff9800' : '#2196f3';
    const [period, setPeriod] = useState<'Month' | 'Year'>('Month');
    const [chartData, setChartData] = useState<{
        categories: string[];
        v2o5: number[];
        feV: number[];
    }>({ categories: [], v2o5: [], feV: [] });
    useEffect(() => {
        const loadData = async () => {
            try {
                const data = await fetchPriceTrend(period);
                setChartData({
                    categories: data?.categories || [],
                    v2o5: data?.v2o5 || [],
                    feV: data?.feV || []
                });
            } catch (error) {
                console.error("Failed to fetch price trend:", error);
            }
        };
        loadData();
    }, [period]);
    const option = {
        backgroundColor: 'transparent',
        tooltip: {
            trigger: 'axis',
            backgroundColor: 'rgba(11, 17, 32, 0.9)',
            borderColor: isChengde ? '#ff9800' : '#2196f3',
            textStyle: { color: '#fff' },
            padding: 16
        },
        legend: { textStyle: { color: '#fff' }, bottom: 0 },
        grid: { left: '12%', right: '10%', top: '20%', bottom: '25%' },
        xAxis: {
            type: 'category',
            boundaryGap: false,
            data: chartData.categories,
            axisLine: { lineStyle: { color: '#03a9f4' } },
            axisLabel: { color: '#fff', rotate: period === 'Month' ? 30 : 0 }
        },
        yAxis: {
            type: 'value',
            axisLine: { show: false },
            splitLine: { lineStyle: { color: 'rgba(255,255,255,0.1)' } },
            axisLabel: { color: '#fff', formatter: (val: number) => (val / 10000).toFixed(0) + '万' }
        },
        series: [
            {
                name: '五氧化二钒',
                type: 'line',
                data: chartData.v2o5,
                smooth: true,
                showSymbol: false,
                lineStyle: { color: highlightColor, width: 3 },
                areaStyle: {
                    color: {
                        type: 'linear', x: 0, y: 0, x2: 0, y2: 1,
                        colorStops: [{ offset: 0, color: isChengde ? 'rgba(255,152,0,0.5)' : 'rgba(33,150,243,0.5)' }, { offset: 1, color: 'rgba(0,0,0,0)' }]
                    }
                },
                animationDuration: 2000,
                animationEasing: 'cubicOut'
            },
            {
                name: '钒铁',
                type: 'line',
                data: chartData.feV,
                smooth: true,
                showSymbol: false,
                lineStyle: { color: '#00e5ff', width: 2 },
                animationDuration: 2500,
                animationEasing: 'cubicOut'
            }
        ]
    };
    return (
        <div className="hud-panel right-panel">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                <h3 style={{ margin: 0 }}>价格走势 ({period === 'Month' ? '近30天' : '近6年'})</h3>
                <div className="period-switch">
                    <button onClick={() => setPeriod('Month')} style={{ background: period === 'Month' ? highlightColor : 'transparent', border: `1px solid ${highlightColor} `, color: '#fff', padding: '2px 8px', marginRight: '5px', borderRadius: '4px' }}>月</button>
                    <button onClick={() => setPeriod('Year')} style={{ background: period === 'Year' ? highlightColor : 'transparent', border: `1px solid ${highlightColor} `, color: '#fff', padding: '2px 8px', borderRadius: '4px' }}>年</button>
                </div>
            </div>
            <ReactECharts option={option} style={{ height: '190px' }} />
        </div>
    );
};
export default MarketPanel;
